import React, { useEffect, useState, Suspense, lazy } from "react";
import { Helmet } from "react-helmet";
import ProjectCardRow from "../../components/ProjectCardRow/ProjectCardRow";
import { getStoredData } from "../../JsonFiles/fetchData";
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";

// Lazy load components
const AllIntroTemplateLazy = lazy(() =>
  import("../../components/AllIntroTemplate/AllIntroTemplate")
);

function OngoingProjectsPage() {
  const [totalData, setTotalData] = useState(null); // State for TotalData
  const [ongoingProjects, setOngoingProjects] = useState([]); // State for ongoing projects
  const [isLoading, setIsLoading] = useState(true); // Loading state

  const structuredData = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    name: "Ongoing Projects - Priya Infra",
    url: "https://www.priyainfra.com/projects/ongoing",
    description:
      "Explore our ongoing construction projects that highlight our commitment to quality and excellence.",
    publisher: {
      "@type": "Organization",
      name: "Priya Infra",
      url: "https://www.priyainfra.com",
    },
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch and set TotalData from local storage
        const storedData = getStoredData();
        if (storedData) {
          setTotalData(storedData);
        }

        // Fetch projects from the backend API
        const projectsResponse = await fetch(
          "https://technow-overseasbackend.vercel.app/projects"
        );
        const projectsData = await projectsResponse.json();

        // ✅ Filter only ongoing projects
        const filtered = projectsData.filter(
          (proj) => proj.status && proj.status.toLowerCase() === "ongoing"
        );

        setOngoingProjects(filtered);
      } catch (error) {
        console.error("Error fetching ongoing projects:", error);
      } finally {
        setIsLoading(false); // Set loading to false after fetch
      }
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <LoadingIcon />; // ✅ Show loading icon while fetching
  }

  if (!totalData || ongoingProjects.length === 0) {
    return (
      <div className="OngoingProjectsPage-empty">
        No ongoing projects found.
      </div>
    );
  }

  return (
    <div className="OngoingProjectsPage-container">
      <Helmet>
        <title>Ongoing Projects - Priya Infra</title>
        <meta
          name="description"
          content="Explore our ongoing infrastructure and construction projects currently under execution by Priya Infra Engineers Pvt Ltd."
        />
        <meta property="og:title" content="Ongoing Projects - Priya Infra" />
        <meta
          property="og:description"
          content="Discover ongoing projects showcasing our commitment to quality and timely delivery."
        />
        <meta
          property="og:url"
          content="https://www.priyainfra.com/projects/ongoing"
        />
        <meta
          property="og:image"
          content="https://www.priyainfra.com/assets/og_ongoing_projects.jpg"
        />{" "}
        {/* Replace with your actual OG image */}
        <meta property="og:type" content="website" />
        <link
          rel="canonical"
          href="https://www.priyainfra.com/projects/ongoing"
        />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      <Suspense fallback={<div>Loading...</div>}>
        <AllIntroTemplateLazy
          description={totalData[0]?.OngoingProjectsDescription}
          image={totalData[0]?.OngoingProjectsImage}
          title={totalData[0]?.OngoingProjectsTitle}
        />
        <ProjectCardRow data={ongoingProjects} />
      </Suspense>
    </div>
  );
}

export default OngoingProjectsPage;
